import { useState, useRef, useEffect } from 'react';
import { formatDate, FORMAT } from '../../../../lib/date';
import { isNumberOrEmpty, convertWeight } from '../../../../lib/utils';
import { WEIGHT_UNIT } from '../../../../types/enum';
import Title from '../../../../components/dialog/title';
import DetailTypes from './detailTypes';
import AddExercise from './addExercise';
import ExerciseList from './exercise';
import CustomTypeDialog from './customType';
import ExtraDetail from './extraDetail';
import request from '../../../../lib/request';

const energyLevel = [
  { color: '🟢', meaning: 'Full' },
  { color: '🟡', meaning: 'Medium' },
  { color: '🔴', meaning: 'Low' },
];

const isMultiDetailTypeWorkout = (type) => {
  return ['home', 'gym', 'core', 'hiit'].includes(type);
};

const WorkoutDateAndDuration = ({
  selectedMonth,
  handleChangeDate,
  duration,
  handleChangeDuration,
}) => {
  return (
    <div className='flex flex-col gap-4 mb-4'>
      <div className='flex items-center justify-between gap-2'>
        <label className='text-white font-semibold'>Date</label>
        <input
          type='datetime-local'
          max={formatDate(new Date(), FORMAT.DATEHOURMIN)}
          value={selectedMonth}
          onChange={handleChangeDate}
          className='rounded-full px-2 py-1 bg-tertiary  text-white'
        />
      </div>
      <div className='flex items-center justify-between gap-2'>
        <label className='text-white font-semibold'>Duration</label>
        <div className='text-white flex items-center gap-2'>
          <div className='flex items-center gap-2'>
            <select
              name='hours'
              value={duration.hours}
              onChange={handleChangeDuration}
              className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-16 text-center'
            >
              {Array.from({ length: 25 }, (_, i) => (
                <option
                  key={i}
                  value={i}
                >
                  {i}
                </option>
              ))}
            </select>
            <span>h</span>
          </div>
          <div className='flex items-center gap-2'>
            <select
              name='minutes'
              value={duration.minutes}
              onChange={handleChangeDuration}
              className='rounded-full px-2 py-1 bg-tertiary  text-white max-w-16 text-center'
            >
              {Array.from({ length: 60 }, (_, i) => (
                <option
                  key={i}
                  value={i}
                >
                  {i}
                </option>
              ))}
            </select>
            <span>min</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const WorkoutFeelingAndNote = ({
  type,
  note,
  handleChangeNote,
  feeling,
  handleSelectFeeling,
  level,
  handleChangeLevel,
  user,
  handleSelectWorkoutEnergyLevel,
  handleSelectCardioEnergyLevel,
  workoutEnergyLevel,
  cardioEnergyLevel,
}) => {
  const [emojiExpression, setEmojiExpression] = useState([]);

  useEffect(() => {
    getEmojiExpression();
  }, []);

  const getEmojiExpression = async () => {
    try {
      const { result } = await request.get('/static/emoji-expression');
      setEmojiExpression(result);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className='mb-4'>
      {user.programRegistered && (
        <div className='flex items-center justify-between gap-2 mb-4'>
          <label className='text-white font-semibold'>Level</label>
          <select
            name='level'
            value={level}
            onChange={handleChangeLevel}
            className='rounded-full px-2 py-1 bg-tertiary  text-white text-center'
          >
            {Array.from({ length: 5 }, (_, i) => (
              <option
                key={i}
                value={i + 1}
              >
                {i + 1}
                {i + 1 === 1 ? ' (easy)' : i + 1 === 5 ? ' (hard)' : ''}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className='text-white font-semibold'>
        <span className='mr-2'>How was today's workout?</span>
        <span className='text-xl space-x-1'>
          {Array.from({ length: 3 }, (_, i) => (
            <span key={i}>{feeling[i] ? feeling[i] : '🫥'}</span>
          ))}
        </span>
      </div>
      <div className='text-xs text-white/50 mb-1'>Select 1-3 best feelings</div>
      <div className='flex items-center gap-4 py-2 overflow-x-scroll scrollbar-hidden mb-4'>
        {emojiExpression.map((item) => (
          <button
            key={item.emoji}
            className={`flex-shrink-0 size-[72px] flex flex-col items-center justify-center gap-1 rounded-xl p-1 ${
              feeling.includes(item.emoji)
                ? 'bg-secondary border-2 border-accent'
                : 'bg-tertiary'
            }`}
            onClick={() => handleSelectFeeling(item.emoji)}
          >
            <span className='text-xl'>{item.emoji}</span>
            <span className='text-[10px] text-white/70 leading-none'>
              {item.meaning}
            </span>
          </button>
        ))}
      </div>

      {['home', 'gym'].includes(type.type) && user.programRegistered && (
        <div>
          <div className='text-white font-semibold'>
            <span className='mr-2'>Workout</span>
          </div>
          <div className='flex items-center gap-4 py-2 overflow-x-scroll scrollbar-hidden mb-4'>
            {energyLevel.map((item) => (
              <button
                key={item.color}
                className={`flex-shrink-0 size-[72px] flex flex-col items-center justify-center gap-1 rounded-xl p-1 ${
                  workoutEnergyLevel === item.color
                    ? 'bg-secondary border-2 border-accent'
                    : 'bg-tertiary'
                }`}
                onClick={() => handleSelectWorkoutEnergyLevel(item.color)}
              >
                <span className='text-xl'>{item.color}</span>
                <span className='text-[10px] text-white/70 leading-none'>
                  {item.meaning}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
      {['home', 'gym'].includes(type.type) && user.programRegistered && (
        <div>
          <div className='text-white font-semibold'>
            <span className='mr-2'>Cardio</span>
          </div>
          <div className='flex items-center gap-4 py-2 overflow-x-scroll scrollbar-hidden mb-4'>
            {energyLevel.map((item) => (
              <button
                key={item.color}
                className={`flex-shrink-0 size-[72px] flex flex-col items-center justify-center gap-1 rounded-xl p-1 ${
                  cardioEnergyLevel === item.color
                    ? 'bg-secondary border-2 border-accent'
                    : 'bg-tertiary'
                }`}
                onClick={() => handleSelectCardioEnergyLevel(item.color)}
              >
                <span className='text-xl'>{item.color}</span>
                <span className='text-[10px] text-white/70 leading-none'>
                  {item.meaning}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}

      <div className='flex flex-col gap-2'>
        <label className='text-white font-semibold'>Note</label>
        <textarea
          value={note}
          rows={2}
          onChange={handleChangeNote}
          className='rounded-xl px-3 py-2 bg-tertiary  text-white resize-none'
        />
      </div>
    </div>
  );
};

const Detail = ({
  type,
  closeDialog,
  refreshWorkoutTracker,
  selectedDate,
  preference,
  user,
}) => {
  const addExerciseRef = useRef(null);
  const addCustomTypeRef = useRef(null);

  const [selectedMonth, setSelectedMonth] = useState('');
  const [duration, setDuration] = useState({
    hours: 0,
    minutes: 0,
  });
  const [feeling, setFeeling] = useState([]);
  const [note, setNote] = useState('');
  const [extra, setExtra] = useState({
    distance: 0,
    steps: 0,
    cycle: 0,
    restCycle: 0,
    restExercise: 0,
  });
  const [selectedDetailType, setSelectedDetailType] = useState([]);
  const [selectedExercises, setSelectedExercises] = useState([]);
  const [customDetailType, setCustomDetailType] = useState([]);
  const [level, setLevel] = useState(1);
  const [loading, setLoading] = useState(false);
  const [workoutEnergyLevel, setWorkoutEnergyLevel] = useState('');
  const [cardioEnergyLevel, setCardioEnergyLevel] = useState('');

  useEffect(() => {
    setSelectedMonth(
      `${selectedDate}T${formatDate(new Date(), FORMAT.HOURMIN)}`
    );
  }, [selectedDate]);

  const handleChangeDate = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleChangeDuration = (e) => {
    if (isNumberOrEmpty(e.target.value)) {
      setDuration({
        ...duration,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleChangeNote = (e) => {
    setNote(e.target.value);
  };

  const handleSelectFeeling = (emoji) => {
    if (feeling.includes(emoji)) {
      setFeeling(feeling.filter((item) => item !== emoji));
    } else if (feeling.length < 3) {
      setFeeling([...feeling, emoji]);
    } else {
      alert('You selected 3 best feelings.');
    }
  };

  const handleChangeLevel = (e) => {
    setLevel(e.target.value);
  };

  const handleSelectWorkoutEnergyLevel = (energy) => {
    setWorkoutEnergyLevel(energy);
  };

  const handleSelectCardioEnergyLevel = (energy) => {
    setCardioEnergyLevel(energy);
  };

  const handleSelectDetailType = (detailType) => {
    if (detailType === 'Custom') {
      openAddCustomTypeDialog();
      return;
    }
    if (selectedDetailType.includes(detailType)) {
      setSelectedDetailType(
        selectedDetailType.filter((item) => item !== detailType)
      );
    } else if (isMultiDetailTypeWorkout(type.type)) {
      if (selectedDetailType.length < 5) {
        setSelectedDetailType([...selectedDetailType, detailType]);
      } else {
        alert('You can only select 5 workout types.');
      }
    } else {
      setSelectedDetailType([detailType]);
    }
  };

  const handleSubmit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const dateArr = selectedMonth.split('T');
      const workout = [...selectedDetailType, ...customDetailType];

      if (workout.length === 0) {
        return alert('Please select workout type.');
      }

      const hours = Number(duration.hours) * 60;
      const minutes = Number(duration.minutes);
      const total = hours + minutes;

      const body = {
        workout: workout.join(','),
        logDate: dateArr[0],
        logTime: dateArr[1],
        duration: total * 60,
        note,
        logs: [],
        type: type.type,
        feeling: feeling.join(','),
        level,
        workoutAt: new Date(selectedMonth).toISOString(),
      };

      if (workoutEnergyLevel || cardioEnergyLevel) {
        body.note =
          `${workoutEnergyLevel ? `Workout ${workoutEnergyLevel}\n` : ''}${
            cardioEnergyLevel ? `Cardio ${cardioEnergyLevel}\n` : ''
          }` + body.note;
      }

      if (type.type === 'cardio') {
        body.distance = Number(extra.distance);
        body.steps = Number(extra.steps);
      }
      if (type.type === 'hiit') {
        body.cycle = Number(extra.cycle);
        body.restCycle = Number(extra.restCycle);
        body.restExercise = Number(extra.restExercise);
      }

      selectedExercises.forEach((exercise) => {
        if (!exercise.groupId) {
          exercise.sets = exercise.sets.map((set) => ({
            ...set,
            weight:
              preference.weightUnit === WEIGHT_UNIT.LB
                ? convertWeight(
                    Number(set.weight),
                    WEIGHT_UNIT.LB,
                    WEIGHT_UNIT.KG
                  )
                : Number(set.weight),
            count: Number(set.count),
          }));
          body.logs.push(exercise);
        } else {
          const eachExercise = exercise.name.map((n, i) => {
            return {
              name: n,
              groupId: exercise.groupId,
              order: i + 1,
              type: exercise.type,
              sets: exercise.sets.map((set) => ({
                ...set[i],
                weight:
                  preference.weightUnit === WEIGHT_UNIT.LB
                    ? convertWeight(
                        Number(set[i].weight),
                        WEIGHT_UNIT.LB,
                        WEIGHT_UNIT.KG
                      )
                    : Number(set[i].weight),
                count: Number(set[i].count),
              })),
            };
          });
          body.logs.push(...eachExercise);
        }
      });

      const { result } = await request.post('/workout/record', body);
      if (result) {
        await refreshWorkoutTracker();
        handleCloseDetailDialog();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const openAddCustomTypeDialog = () => {
    addCustomTypeRef.current.showModal();
  };

  const closeAddCustomTypeDialog = () => {
    addCustomTypeRef.current.close();
  };

  const openAddExerciseDialog = () => {
    addExerciseRef.current.showModal();
  };

  const closeAddExerciseDialog = () => {
    addExerciseRef.current.close();
  };

  const handleCloseDetailDialog = () => {
    setSelectedDetailType([]);
    setCustomDetailType([]);
    setSelectedExercises([]);
    setFeeling([]);
    setNote('');
    setExtra({
      distance: 0,
      steps: 0,
      cycle: 0,
      restCycle: 0,
      restExercise: 0,
    });
    setDuration({
      hours: 0,
      minutes: 0,
    });
    closeDialog();
  };

  const handleSetSelectedExercises = (exercises) => {
    setSelectedExercises([...selectedExercises, ...exercises]);
  };

  const handleDeleteExercise = (index) => {
    if (window.confirm('Are you sure you want to delete this exercise?')) {
      setSelectedExercises(selectedExercises.filter((_, i) => i !== index));
    }
  };

  const handleAddCustomDetailType = (customType) => {
    if (!isMultiDetailTypeWorkout(type.type)) {
      setSelectedDetailType([]);
    }
    setCustomDetailType([...customDetailType, customType]);
  };

  const handleRemoveCustomDetailType = (index) => {
    setCustomDetailType(customDetailType.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div className='flex items-center justify-between'>
        <Title
          title={type.name}
          onClick={handleCloseDetailDialog}
          color='white'
        />
      </div>

      <WorkoutDateAndDuration
        selectedMonth={selectedMonth}
        handleChangeDate={handleChangeDate}
        duration={duration}
        handleChangeDuration={handleChangeDuration}
      />

      <ExtraDetail
        type={type.type}
        extra={extra}
        setExtra={setExtra}
      />

      <DetailTypes
        type={type}
        selectedDetailType={selectedDetailType}
        handleSelectDetailType={handleSelectDetailType}
        customDetailType={customDetailType}
        handleRemoveCustomDetailType={handleRemoveCustomDetailType}
        openAddExerciseDialog={openAddExerciseDialog}
        isMultiDetailTypeWorkout={isMultiDetailTypeWorkout(type.type)}
      />

      <ExerciseList
        selectedExercises={selectedExercises}
        setSelectedExercises={setSelectedExercises}
        handleDeleteExercise={handleDeleteExercise}
        preference={preference}
      />

      <WorkoutFeelingAndNote
        type={type}
        note={note}
        feeling={feeling}
        handleSelectFeeling={handleSelectFeeling}
        handleChangeNote={handleChangeNote}
        level={level}
        handleChangeLevel={handleChangeLevel}
        user={user}
        workoutEnergyLevel={workoutEnergyLevel}
        cardioEnergyLevel={cardioEnergyLevel}
        handleSelectWorkoutEnergyLevel={handleSelectWorkoutEnergyLevel}
        handleSelectCardioEnergyLevel={handleSelectCardioEnergyLevel}
      />

      <CustomTypeDialog
        dialogRef={addCustomTypeRef}
        closeDialog={closeAddCustomTypeDialog}
        handleAddCustomDetailType={handleAddCustomDetailType}
      />
      <AddExercise
        dialogRef={addExerciseRef}
        closeDialog={closeAddExerciseDialog}
        selectedDetailType={selectedDetailType}
        handleSetSelectedExercises={handleSetSelectedExercises}
      />

      <button
        onClick={handleSubmit}
        className='rounded-full w-full py-2 bg-accent font-bold'
        disabled={loading}
      >
        Save
      </button>
    </div>
  );
};

export default Detail;
